import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "translate(4.125, 2.2) scale(1.3)",
		d: "M1.25 12.8285H4.03854V7.87667H8.46146V12.8285H11.25V5.32854L6.25 1.5625L1.25 5.32854V12.8285ZM0 14.0785V4.70354L6.25 0L12.5 4.70354V14.0785H7.21146V9.12667H5.28854V14.0785H0Z",
		fill: "currentColor"
	})
});
export default SvgHome;
